export const Attributes = {
  POSITION: "position",
  MODE: "mode",
  SHOW_ARROW: "show-arrow",
  DELAY: "delay",
  DELAY_ON: "delay-on",
  DELAY_OFF: "delay-off",

  // A11y
  ARIA_DESCRIBEDBY: "aria-describedby",
  ROLE: "role",
}

export const Positions = {
  BLOCK_START: "block-start",
  BLOCK_END: "block-end",
  INLINE_START: "inline-start",
  INLINE_END: "inline-end",
}

export const Modes = {
  DARK: "dark",
  LIGHT: "light",
}

export const ClassNames = {
  ARROW: "arrow",
  VISIBLE: "visible",
  HIDDEN: "hidden",
}

export const Slots = {
  TRIGGER: "[slot='trigger']",
  CONTENT: "[slot='content']",
}

export const TIMEOUT_DELAY = 300
export const ESCAPE_KEY = "Escape"
